import React, { useState } from "react";
import Helpers from "../../helpers/helpers";
import Styled from "./GatewayWSPAYForm.styles";
import l10n from "../../localization";
import { IconPayBill } from "../../components/Icons/Icons";

function GatewayWSPAYForm(props) {
  const displayUrl = window.location.origin + window.location.pathname;

  const [redirecting, setRedirecting] = useState(false);

  const onSubmit = () => {
    setRedirecting(true);
  };

  if (props.invoice.isPayed === "Open") {
    return (
      <React.Fragment>
        <form
          name="pay"
          action={process.env.REACT_APP_WSPAY_URL}
          method="POST"
          onSubmit={onSubmit}
        >
          <input type="hidden" name="ShopID" value="VODOVODOS" />
          <input
            type="hidden"
            name="ShoppingCartID"
            value={props.invoice.invoiceId}
          />
          <input
            type="hidden"
            name="TotalAmount"
            value={Helpers.formatNumber(props.invoice.invoiceValue)}
          />
          <input
            type="hidden"
            name="Signature"
            value={props.invoice.wsPaySignature}
          />
          <input
            type="hidden"
            name="ReturnURL"
            value={`${displayUrl}?transaction=success`}
          />
          <input
            type="hidden"
            name="CancelURL"
            value={`${displayUrl}?transaction=canceled`}
          />
          <input
            type="hidden"
            name="ReturnErrorURL"
            value={`${displayUrl}?transaction=error`}
          />
          {props.children ? (
            props.children
          ) : (
            <Styled.button
              color="success"
              disabled={props.disabled || redirecting}
            >
              <IconPayBill></IconPayBill>
              {redirecting && l10n.invoices.loading}
              {!redirecting && l10n.invoices.payOnline}
            </Styled.button>
          )}
        </form>
      </React.Fragment>
    );
  }

  return null;
}

export default GatewayWSPAYForm;
